import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import MatchDots from "../../components/ExcerciseTypes/LineTo/MatchDots";
const json = {
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page8/Demo/Key1.png",
    component: T6,
    isHiddenCheck: true,
    // hideBtnFooter: true,
    maxLength: 3,
    stylesTextInput: {
      fontSize: 23,
      borderBottom: "2px dotted black",
      textAlign: "center",
    },
    inputSize: 60,
    textareaStyle: { width: 800, border: "2px solid black" },
    newWords: [
      {
        title: "Tra cứu",
        description: `
        <span>Tra cứu</span>
        
        `,
      },
    ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>hướng dẫn</span>
        
        `,
      },
    ],
    titleQuestion: [
      {
        num: "",
        title: ` <img src="img/FriendsPlus/Page8/Demo/1.jpg" style="height:30mm;margin-left:-70px;margin-top:-30px "/> `,
        color: "rgb(3, 103, 181)",
        // star: 1
      },
    ],
    // recorder: true,

    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='display:flex'>
        	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
        	  <b>1</b>
        	</div>
        		Quan sát thước đo rồi nêu số đo của mỗi góc (theo mẫu).
        </div> 
        <div style='position:relative'> 
              <div style='display:flex'> 
                <img src="img/FriendsPlus/Page8/Demo/2.jpg" style="height:8cm;margin:10px 40px"/>
                <div>
                <table style="border-collapse: collapse; width: 100%; max-width: 600px; margin: 20px auto;">

                    <tr style="border-color:red">
                      <td style="width:400px;border: 1px solid black; padding: 10px; text-align: center; background-color: #0074D9">Góc</td>
                      <td style="width:200px;border: 1px solid black; padding: 10px; text-align: center;">Số đo góc</td>
                    </tr>
                    <tr style="">
                      <td style="width:400px;border: 1px solid black; padding: 10px; text-align: center; ">Góc đỉnh A, cạnh AB, AD</td>
                      <td style="width:200px;border: 1px solid black; padding: 10px; text-align: center;"> <span style='color:white'>2</span>90 °</td>
                    </tr>
                    <tr style="">
                      <td style="width:400px;border: 1px solid black; padding: 10px; text-align: center; ">Góc đỉnh B, cạnh BA, BC</td>
                      <td style="width:200px;border: 1px solid black; padding: 10px; text-align: center;">#</td>
                    </tr>
                    <tr style="">
                      <td style="width:400px;border: 1px solid black; padding: 10px; text-align: center; ">Góc đỉnh C, cạnh CB, CD</td>
                      <td style="width:200px;border: 1px solid black; padding: 10px; text-align: center;">#</td>
                    </tr>
                    <tr style="">
                      <td style="width:400px;border: 1px solid black; padding: 10px; text-align: center; ">Góc đỉnh D, cạnh DA, DC</td>
                      <td style="width:200px;border: 1px solid black; padding: 10px; text-align: center;">#</td>
                    </tr>


                  </table>
                </div>              
              </div>
              <div style='position:absolute;top:147px;left:911px;width:4cm'>
                  °
              </div>
              <div style='position:absolute;top:205px;left:911px;width:4cm'>
                  °
              </div>
              <div style='position:absolute;top:263px;left:911px;width:4cm'>
                  °
              </div>
        </div>
        
            
            
            
        `,
        answer: ["60", "90", "120"],
      },
    ],
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/Page8/Demo/Key2.png",
    component: T6,
    isHiddenCheck: true,
    newWords: [
      {
        title: "Tra cứu",
        description: `
        <span>Tra cứu</span>
        
        `,
      },
    ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>hướng dẫn</span>
        
        `,
      },
    ],
    protractor: [
      {
        decreaseLeft: 190,
        decreaseTop: 220,

        rotateLeftThan0: 40,
        rotateTopThan0: 40,

        rotateLeftLess0: -20,
        rotateTopLess0: 50,

        inputLeft: "1066px",
        inputBottom: "66px",
        result: [
          {
            id: 0,
            top: 131, // top cây thước sau khi đặt vô hình
            left: -128, // left cây thước sau khi đặt vô hình
            rotate: 0,
          },
          {
            id: 1,
            top: 130, // top cây thước sau khi đặt vô hình
            left: -131, // left cây thước sau khi đặt vô hình
            rotate: 121,
          },
        ],
      },
    ],
    hideBtnFooter: true,
    maxLength: 3,
    stylesTextInput: { fontSize: 23, borderBottom: "none", textAlign: "end" },
    inputSize: 60,
    textareaStyle: { width: 800 },
    titleQuestion: [
      {
        num: "",
        title: ` <img src="img/FriendsPlus/Page8/Demo/1.jpg" style="height:30mm;margin-left:-20px;margin-top:-30px "/> `,
        color: "rgb(3, 103, 181)",
        // star: 1
      },
    ],
    // recorder: true,

    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        
        <div style='display:flex'>
        	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
        	  <b>2</b>
        	</div>
          Dùng thước đo góc để đo góc đỉnh B; cạnh BA, BC
        </div>
        
        <div style="position: relative;">
        <img src="/img/FriendsPlus/Page8/Demo/3.jpg"  style="height:8cm;margin-top:50px;position:absolute;top:0px;left:0px" >
        
        <div style='margin-left:150px; position: absolute;  left:-6px; top: 79px;z-index:10' >
          <div id="0" style='background: rgb(89 188 141);  border-radius: 50%; color: white;padding: 2px 6px; text-align:center;display:none; '>
            <span 
            >60</span>
          </div>
        </div>

        <div style='margin-left:150px; position: absolute;  left:122px; top: 281px;z-index:10' >
          <div id="1" style='background: rgb(89 188 141);  border-radius: 50%; color: white;padding: 2px 6px; text-align:center;display:none; '>
            <span 
            >60</span>
          </div>
        </div>





        <div
          style="
            position: absolute;
            left: 65px;
            top: 294px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
          "
          ></div>
      
      </div>
      <div
          id="protractor"
          style="position: absolute;top: 454px;left: 0px;width: 400px; height: 420px;z-index: 1"
        >
          <img
            src="/img/test/protractor-removebg-preview2.png"
            style="width: 400px"
            alt="image"
          />
        </div>
      
        `,
        answer: ["60", "120", "90", "60"],
      },
    ],
  },
  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/Page8/Demo/Key2.png",
    component: T6,
    isHiddenCheck: true,
    newWords: [
      {
        title: "Tra cứu",
        description: `
        <span>Tra cứu</span>
        
        `,
      },
    ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>hướng dẫn</span>
        
        `,
      },
    ],
    protractor: [
      {
        decreaseLeft: 190,
        decreaseTop: 220,

        rotateLeftThan0: 40,
        rotateTopThan0: 40,

        rotateLeftLess0: -20,
        rotateTopLess0: 50,

        inputLeft: "825px",
        inputBottom: "55px",
        result: [
          {
            id: 0,
            top: 52,
            left: -62,
            rotate: 0,
          },
          {
            id: 1,
            top: 52,
            left: -62,
            rotate: 90,
          },
          {
            id: 2,
            top: 53,
            left: 237,
            rotate: 30,
          },
          {
            id: 3,
            top: 53,
            left: 237,
            rotate: 90,
          },
          {
            id: 4,
            top: 55,
            left: 538,
            rotate: 90,
          },
          {
            id: 5,
            top: 55,
            left: 538,
            rotate: -90,
          },
          {
            id: 6,
            top: 57,
            left: 839,
            rotate: -30,
          },
          {
            id: 7,
            top: 57,
            left: 839,
            rotate: 90,
          },
        ],
      },
    ],
    hideBtnFooter: true,
    maxLength: 3,
    stylesTextInput: { fontSize: 23, borderBottom: "none", textAlign: "end" },
    inputSize: 60,
    textareaStyle: { width: 800 },
    titleQuestion: [
      {
        num: "",
        title: ` <img src="img/FriendsPlus/Page8/Demo/1.jpg" style="height:30mm;margin-left:-20px;margin-top:-30px "/> `,
        color: "rgb(3, 103, 181)",
        // star: 1
      },
    ],
    // recorder: true,

    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='display:flex; '>
        	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
        	  <b>3</b>
        	</div>
          Dùng thước đo góc để đo các góc được tạo bởi hai kim đồng hồ khi đồng hồ chỉ 3 giờ, 4giờ, 6giờ, 2 giờ.
        </div>
        
        
         
          <div   style="position: absolute; top: 150px; left: 39px;">
            <img   src="/img/FriendsPlus/Page8/Demo/4.jpg"  width='200px'/>
          </div>

          <div  style="position: absolute; top: 257px; left: 133px;background-color: red; border-radius: 50%; width:10px;height:10px;z-index:1">
          </div>

          <div id='0' style="position: absolute; top: 15px;left: 119px; background-color: rgb(89, 188, 141); border-radius: 50%; color: white;padding: 2px 6px;display:none">
            <span >90</span>
          </div>

          <div id='1' style="position: absolute; top: 238px;left: 313px; background-color: rgb(89, 188, 141); border-radius: 50%; color: white;padding: 2px 6px;z-index:10; display:none">
            <span >90</span>
          </div>

          <div style="position: absolute; top: 150px; left: 339px;">
            <img src="/img/FriendsPlus/Page8/Demo/5.jpg"  width='200px'/>
          </div>

          <div  style="position: absolute; top: 259px; left: 433px;background-color: red; border-radius: 50%; width:10px;height:10px;z-index:1">
          </div>

          <div id='2' style="position: absolute; top: 14px;left: 419px; background-color: rgb(89, 188, 141); border-radius: 50%; color: white;padding: 4px 6px;display:none">
            <span >120</span>
          </div>

          <div id='3' style="position: absolute; top: 340px;left: 619px; background-color: rgb(89, 188, 141); border-radius: 50%; color: white;padding: 4px 6px;z-index:1;display:none">
            <span >120</span>
          </div>

          <div style="position: absolute; top: 150px; left: 639px;">
            <img src="/img/FriendsPlus/Page8/Demo/6.jpg"  width='200px'/>
          </div>

          <div  style="position: absolute; top: 260px; left: 734px;background-color: red; border-radius: 50%; width:10px;height:10px;z-index:1">
          </div>

          <div id='4' style="position: absolute; top:14px;left: 717px; background-color: rgb(89, 188, 141); border-radius: 50%; color: white;padding: 5px 6px;display:none">
            <span >180</span>
          </div>

          <div id='5' style="position: absolute; top:14px;left: 717px; background-color: rgb(89, 188, 141); border-radius: 50%; color: white;padding: 5px 6px;display:none">
          <span >180</span>
          </div>

        <div style="position: absolute; top: 150px; left: 939px;">
        <img src="/img/FriendsPlus/Page8/Demo/7.jpg"  width='200px'/>
        </div>

      <div  style="position: absolute; top: 261px; left: 1034px;background-color: red; border-radius: 50%; width:10px;height:10px;z-index:1">
      </div>

      <div id='6' style="position: absolute; top: 23px;left: 1020px; background-color: rgb(89, 188, 141); border-radius: 50%; color: white;padding: 2px 6px;display:none">
          <span >60</span>
        </div>

        <div id='7' style="position: absolute; top: 134px;left: 1215px; background-color: rgb(89, 188, 141); border-radius: 50%; color: white;padding: 2px 6px;display:none">
          <span >60</span>
        </div>
         


        <div
          id="protractor"
          style="position: absolute;top: 454px;left: 0px;width: 400px; height: 420px;z-index: 1"
        >
          <img
            src="/img/test/protractor-removebg-preview2.png"
            style="width: 400px"
            alt="image"
          />
        </div>

       
            
        `,
        answer: ["60", "120", "90", "60"],
      },
    ],
  },

  //   3: {
  //     unit: "Unit Starter",
  //     id: "FP8-WB-demo-2023-US-P8-E3",
  //     audio: "",
  //     exerciseKey: "/img/FriendsPlus/Page8/Key/E3answerKey.png",
  //     component: T6v2,
  //     inputSize: 93,

  //     stylesTextInput: {
  //       fontSize: "24px",
  //       background: "transparent",
  //       textAlign: "center",
  //       borderStyle: "dotted",
  //       fontWeight:700,
  //     },
  //     titleQuestion: [
  //       {

  //         title: `<div style='display:flex'>
  //         <div style="background-color: rgb(61, 184, 187); border-radius: 50%; color: white; width: 39px; height: 39px; text-align: center; line-height: 39px;margin-right:10px">
  //         3
  //     </div>        <div style='background:rgb(250,235,125);padding:5px 10px;border-radius:10px;text-align: center; '>
  //         <span>Số
  //         </span>
  //         </div>
  //         <div style='margin-left:5px;margin-top:5px'>
  //         ?
  //         </div>
  //         </div>
  //         </div>`,
  //         color: "rgb(28, 192, 217)",
  //       },
  //     ],
  //     maxLength:8,
  //     questionImage: [],
  //     isHiddenCheck: true,
  //     questions: [
  //       {
  //         title: `

  //         <div style='margin-top:-10px'>
  //         <div style='position:relative'>
  //         <div>
  //          <img style='width:30cm' src='img/FriendsPlus/Page8/E3/1.jpg' />
  //           </div>
  //         <div style='position:absolute;top:93px;left:470px;'>
  //           <input/>
  //             </div>
  //         <div style='position:absolute;top:224px;left:328px;'>
  //           <input/>
  //             </div>
  //         <div style='position:absolute;top:380px;left:235px;'>
  //           <input/>
  //              </div>
  //         <div style='position:absolute;top:540px;left:192px;'>
  //           <input/>
  //               </div>
  //         </div>
  //         </div>

  //         `,
  //         answer: [
  //           "7", "5 000 | 5000", "700", "90 000 | 90000",
  //         ],
  //       },
  //     ],
  //   },
  //   4: {
  //     unit: "Unit Starter",
  //     id: "FP8-WB-demo-2023-US-P8-E4",
  //     audio: "",
  //     exerciseKey: "/img/FriendsPlus/Page8/Key/E4answerKey.png",
  //     component: T6v2,
  //     textareaStyle: { width: 600 },
  //     inputSize: 200,
  //     stylesTextInput: {
  //       fontSize: "28px",
  //       background: "transparent",
  //       textAlign: "center",
  //       borderStyle: "dotted",
  //       fontWeight:700,
  //     },
  //     titleQuestion: [
  //       {

  //         title: `
  //         <div style='display:flex'>
  //         <div style="background-color: rgb(61, 184, 187); border-radius: 50%; color: white; width: 39px; height: 39px; text-align: center; line-height: 39px;margin-right:10px">
  //         4
  //     </div>
  //     Trong bốn ngày đầu của tuần chiến dịch tiêm vắc-xin phòng COVID-19, thành phố A đã tiêm được
  //         số liều vắc-xin như sau:
  //         </div>

  //         `,
  //         color: "rgb(28, 192, 217)",
  //       },
  //     ],
  //     questionImage: [],
  //     isHiddenCheck: true,
  //     questions: [
  //       {
  //         title: `
  //         <div style='display:flex'>
  //         <div style='line-height:2'>
  //         Thứ Hai: 36 785 liều vắc-xin <br>
  //         Thứ Tư: 37 243 liều vắc-xin
  //         </div>
  //         <div style='margin-left:50px;line-height:2'>
  //         Thứ Ba: 35 952 liều vắc-xin <br>
  //         Thứ Năm: 20 419 liều vắc-xin
  //         </div>
  //         </div>

  //         <div style='margin-top:10px;line-height:2.5;width:1200px'>
  //         <div style='display:flex'>
  //         a)
  //         <div style='margin-left:10px'>
  //         Ngày nào thành phố A tiêm được nhiều liều vắc-xin nhất? <br> Ngày nào thành phố A tiêm được
  //         ít liều vắc-xin nhất?
  //         </div>
  //         <div style='margin-left:10px'>
  //        <input/> <br> <input/>
  //         </div>
  //         </div>
  //         <div style='display:flex'>
  //         b)	 <div style='margin-left:10px'>
  //         Viết tên các ngày theo thứ tự có số liều vắc-xin đã tiêm được từ ít nhất đến nhiều nhất. <br>
  //         <div style='word-spacing:5px'>
  //        <span> Thứ: #</span><span> Thứ: #</span><span> Thứ: #</span><span> Thứ: #</span>

  //         </div>

  //         </div>
  //         </div>
  //         </div>

  //         `,
  //         answer: [
  //         `Thứ Năm`,`Thứ Ba`,`Ba`,`Hai`,`Tư`,`Năm`,
  //         ],
  //       },
  //     ],
  //   },
  //   5:{
  //     // Exercise num
  //     unit: "Unit 2",
  //     id: "SB7-U2-P57-E2",
  //     audio: "",
  //     video: "",

  //     exerciseKey: "/img/FriendsPlus/Page8/Key/E5answerKey.png",
  //     titleQuestion: [
  //       {
  //         num: "2",
  //         title: "Match 1–6 with a–f. Listen and check.",
  //         color: "#2E479B",
  //       },
  //     ],
  //     component: MatchDots,
  //     question: {
  //       DrawLines: {
  //         // multipleLine: true,
  //         boxMatch: [
  //           {
  //             boxMatchStyle: {
  //               position: "absolute",
  //               top: "17px",
  //               left: "165px",
  //               width: 30,
  //               height: 30,
  //               // backgroundColor: "white",
  //               border: "1px solid",
  //               borderRadius: "50%",
  //             },
  //           }, //0
  //           {
  //             boxMatchStyle: {
  //               position: "absolute",
  //               top: "52px",
  //               left: "277px",
  //               width: 30,
  //               height: 30,
  //               // backgroundColor: "white",
  //               border: "1px solid",
  //               borderRadius: "50%",
  //             },
  //           }, //1
  //           {
  //             boxMatchStyle: {
  //               position: "absolute",
  //               top: "89px",
  //               left: "269px",
  //               width: 30,
  //               height: 30,
  //               // backgroundColor: "white",
  //               border: "1px solid",
  //               borderRadius: "50%",
  //             },
  //           }, //2
  //           {
  //             boxMatchStyle: {
  //               position: "absolute",
  //               top: "123px",
  //               left: "276px",
  //               width: 30,
  //               height: 30,
  //               // backgroundColor: "white",
  //               border: "1px solid",
  //               borderRadius: "50%",
  //             },
  //           }, //3
  //           {
  //             boxMatchStyle: {
  //               position: "absolute",
  //               top: "159px",
  //               left: "367px",
  //               width: 30,
  //               height: 30,
  //               // backgroundColor: "white",
  //               border: "1px solid",
  //               borderRadius: "50%",
  //             },
  //           }, //4

  //         ],
  //         answers: [],
  //         initialValue: ['0-1'],
  //       },
  //       Layout: `
  //         <div style='display:flex;font-size:24px'>
  //             <div >
  //                 <b>1</b> I’m afraid …<br>
  //                 <b>2</b> His phone’s ringing, …<br>
  //                 <b>3</b> Wait! Wait! Please, …<br>
  //                 <b>4</b> Sorry, I can’t hear you.<br>
  //                 <b>5</b> Oh, I need to top up my
  //                   phone. <br>
  //                 <b>6</b> Hello, is that Susan?<br>
  //             </div>
  //             <div style='margin-left:130px'>
  //                 <b>a </b> I haven’t got any credit.<br>
  //                 <b>b </b> … but he’s not answering<br>
  //                 <b>c </b> Can you speak up?<br>
  //                 <b>d </b> … you’ve got the wrong
  //                 number.<br>
  // <b>e </b> … don’t hang up.<br>
  //                 <b>f </b> No, it’s Janet.<br>
  //             </div>
  //         </div>
  //           <input id='0' type= 'boxMatch' />
  //           <input id='1' type= 'boxMatch' />
  //           <input id='2' type= 'boxMatch' />
  //           <input id='3' type= 'boxMatch' />

  //       `,
  //     },
  //   },
};

export default json;
